export default {
  changeLanguageTips: '切換語言成功',
  unknownError: '未知錯誤，請聯系管理員！',
}
